import React from "react"
import Container from "@ecom/ui/components/Container"

import * as styles from "./FourthStep.module.scss"

export default function FourthStep() {
  return (
    <Container>
      <div className={styles.text_container}>
        <p className={styles.muted_text}>
          * Пакет с защитой 4+, пакет с&nbsp;защитой 4, пакет с&nbsp;защитой 3, пакет с&nbsp;защитой
          2 - активируются при&nbsp;оплате их стоимости собственными средствами, в&nbsp;рассрочку
          или&nbsp;за&nbsp;счёт кредитных средств, предоставленных любым банком.
          <br />
          ** В зависимости от выбранного варианта после прохождения Программы Вам доступны различные
          лимиты кредитования.
        </p>
        <p className={styles.text}>
          Банк оставляет за собой право отказать в получении кредита по причинам, не связанным с
          кредитной историей
        </p>
        <h3 className={styles.final}>Улучшайте кредитную историю в Совкомбанке!</h3>
      </div>
    </Container>
  )
}
